import React, { memo } from 'react';
import { styled } from 'linaria/react';
import { useSelector } from 'react-redux';
import { Header } from 'common/components/header';
import { withModel } from 'domains/pageModel/hocs/with-model.hoc';
import { getCookies, selectIsHideHeaderAndFooter, selectUserCookies } from 'common/store/selectors';
import { getPageModel } from 'domains/pageModel/store/selectors';
import { getCustomerId } from 'domains/configurator/store/selectors';
import { PageMeta } from './root-meta.component';
import { useGAPageView } from './hooks/ga-page-view';

export const PageComponent: React.FC<{}> = memo(({ children }) => {
  const isHideHeaderAndFooter = useSelector(selectIsHideHeaderAndFooter);
  const userData = useSelector(selectUserCookies);
  const cookies = useSelector(getCookies);
  const pageModel = useSelector(getPageModel);
  const customerId = useSelector(getCustomerId);
  const regionId = pageModel?.properties?.regionId ?? cookies?._regionID;

  useGAPageView({ userData, customerId, regionId });

  return (
    <Container>
      <PageMeta />
      {isHideHeaderAndFooter ? null : <Header />}
      <ContentContainer>{children}</ContentContainer>
    </Container>
  );
});

const Container = styled.div`
  overflow: hidden;
  color: var(--text-primary);
  background-color: var(--background-primary);
`;

const ContentContainer = styled.div`
  @media (--from-tablet) {
    margin-right: auto;
    margin-left: auto;
  }

  @media (--only-large-desktop) {
    width: 1180px;
  }

  @media (--only-desktop) {
    width: 940px;
  }

  @media (--only-tablet) {
    width: 660px;
  }

  @media (--only-mobile) {
    margin-right: var(--space-200);
    margin-left: var(--space-200);
  }
`;

export const Page = withModel(PageComponent);
